import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import cn from 'classnames'

import Icon from 'components/common/elements/Icon'

import styles from './Menu.scss'

const Menu = ({ sections, menuOpened, pathname }) => {
  return (
    <div className={styles.navigation}>
      <div className={styles.navigationBtn}>
        <Icon icon={menuOpened ? "logo" : "logo_squere" }
              className={cn(styles.Logo, {[styles.LogoSmall]: !menuOpened})}
        />
      </div>
      { sections.map(({ path, label, icon, color }) =>(
        <Link key={path}
              to={path}
              className={cn(styles.navItem, {
                [styles.activeNav]: pathname == path,
                [styles.navItemFullShow]: menuOpened}
              )}
        >
          <div className={styles.navItemIcon}>
            <Icon icon={icon} size={40} color={color} style={{
              position: 'relative',
              top: '2.5px',
            }}/>
          </div>
          <div className={cn(styles.navItemLabel, {[styles.navItemFullShow]: menuOpened})}>
            { label }
          </div>
        </Link>
      ))
      }
    </div>
  )
}

Menu.propTypes = {
  sections: PropTypes.array.isRequired,
  menuOpened: PropTypes.bool.isRequired,
  pathname: PropTypes.string.isRequired,
};

export default Menu
